import gql from 'graphql-tag';

import { commentFragment } from './CommentFragment.fragment';

// eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming, graphql-relay-compat/no-apollo-fragments -- Read https://go/connie-relay-migration-fyi
export const ActiveCommentsQuery = gql`
	query ActiveCommentsQuery(
		$pageId: ID!
		$contentStatus: [GraphQLContentStatus]
		$type: [CommentType]
	) @allowHigherTimeout {
		comments(
			pageId: $pageId
			contentStatus: $contentStatus
			depth: ROOT
			confluenceCommentFilter: { commentState: UNRESOLVED, commentType: $type }
			singleThreaded: true
			type: $type
		) {
			nodes {
				...commentFragment
				replies {
					...commentFragment
				}
			}
			totalCount
		}
	}
	${commentFragment}
`;
